/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SlideshowIcon = /*#__PURE__*/ createSvgIcon(
  'SlideshowIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M14.604 8.854a.588.588 0 00.292-.52.588.588 0 00-.292-.522l-4.062-2.604a.573.573 0 00-.636-.031.587.587 0 00-.323.552v5.208c0 .25.108.434.323.553a.573.573 0 00.636-.032l4.062-2.604zM6.667 15c-.459 0-.851-.163-1.177-.49A1.605 1.605 0 015 13.333v-10c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h10c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177v10c0 .459-.164.851-.49 1.177-.327.327-.719.49-1.177.49h-10zm0-1.667h10v-10h-10v10zm-3.334 5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.176V5.833c0-.236.08-.434.24-.593.16-.16.358-.24.594-.24s.434.08.594.24c.16.16.24.357.24.593v10.834h10.833c.236 0 .434.08.594.24.16.159.24.357.24.593s-.08.434-.24.594a.806.806 0 01-.594.24H3.333z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SlideshowIcon;
